import { Link } from 'react-router-dom';
import { To } from 'history';

// material-ui
import { ButtonBase } from '@mui/material';
import { SxProps } from '@mui/system';

// project-imports
// import Logo from './LogoMain';
// import LogoIcon from './LogoIcon';
import LogoV2Sub from './LogoV2Sub';
import LogoV2 from './LogoV2';

// ==============================|| MAIN LOGO ||============================== //

interface Props {
  reverse?: boolean;
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
}

const LogoSection = ({ reverse, isIcon, sx, to }: Props) => (
  <ButtonBase
    disableRipple
    component={Link}
    // to={!to ? APP_DEFAULT_PATH : to}
    to="#"
    sx={sx}
  >
    {/* {isIcon ? <LogoIcon /> : <Logo reverse={reverse} />}
    <Logo /> */}
    {isIcon ? <LogoV2Sub /> : <LogoV2 />}
  </ButtonBase>
);

export default LogoSection;
